import gql from 'graphql-tag'

import { AddressFieldsFragment } from '../address'

export { SchoolFields as ISchool } from './__generated__/SchoolFields'

export const SchoolFieldsFragment = gql`
  fragment SchoolFields on School {
    id
    slug
    name
    permalink
    programType
    closedAt
    timezone
    currentOnboardingSlug
    isOnboarding
    migratedToWsCenters
    address {
      ...AddressFields
    }
    profile {
      id
      networkRating
      primaryProfileMedia: profileMedia(onlyPrimary: true) {
        media {
          id
          url
        }
      }
    }
    networks {
      id
    }
  }

  ${AddressFieldsFragment}
`
